module.exports = __webpack_public_path__ + "img/social-media-display-chevy.abfbd029.png";